<script>

import { registerPlugin } from "@capacitor/core";
const BackgroundGeolocation = registerPlugin("BackgroundGeolocation");

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      location: null,
      watcherId: null,
      intervalId: null, // برای ذخیره شناسه interval
    };
  },
  computed: {
    ...mapGetters(['baseUrl', 'appToken', "auth"])
  },
  created() {
    this.startGeolocation();
  },
  beforeDestroy() {
    // پاک کردن interval هنگام نابود شدن کامپوننت
    clearInterval(this.intervalId);
    if (this.watcherId) {
      BackgroundGeolocation.removeWatcher({ id: this.watcherId });
    }
  },
  methods: {
    async startGeolocation() {
      await this.guess_location();
    },
    async guess_location() {
      try {
        this.watcherId = await BackgroundGeolocation.addWatcher(
          {
            requestPermissions: true, // درخواست مجوز
            stale: true
          },
          (location, error) => {
            if (error) {
              console.error("Error getting location:", error);
              return;
            }
            this.location = location;
          }
        );

        // ارسال موقعیت هر 15 ثانیه
        this.intervalId = setInterval(() => {
          if (this.location) {
            this.sendLocationToServer(this.location);
          }
        }, 15000); // 15000 میلی‌ثانیه = 15 ثانیه

      } catch (error) {
        console.error("Error adding watcher:", error);
      }
    },

    sendLocationToServer(location) {
      let param = {
        latitude: location.latitude,
        longitude: location.longitude,
        uid: this.auth.uid,
        status: ''
      }

      fetch(this.baseUrl + '/save-current-location', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to send location data to server.');
        }
        console.log('Location sent successfully');
      })
      .catch(error => {
        console.error('Error sending location data to server:', error);
      });
    },
  }
}

</script>

<style scoped>
button {
  margin: 10px;
}
</style>